import {
  BackgroundListType,
  BackgroundMappingType,
  IFormNewBackground,
  ResultsFoundType,
} from "@app/types/background.types";
import { useBackground } from "./useBackground";
import {
  MEDIO_FILTER_OPTIONS,
  PROCESS_OPTIONS,
  PROCESS_OPTIONS_VALUE,
  TYPE_RESULT_TABLE,
} from "./constans";
import { UserType } from "@app/types/genericTables.types";
import { initialRowsCalculation } from "./calculation.rows";
import { initialRowsResult } from "./result.rows";

export const mapBackgroundForm = (
  payload: IFormNewBackground
): BackgroundMappingType => {
  return {
    id: payload.id,
    code: payload.code,
    description: payload.description,
    type:
      payload.type && typeof payload.type === "object"
        ? payload.type.value
        : payload.type,
    counting_time: payload.counting_time || null,
    creation_date: payload.creation_date || null,
    calculation_date: payload.calculation_date || null,
    equipment: payload.equipment?.id || null,
    instalation: payload.instalation?.id || null,
    analyst: payload.analyst
      ? typeof payload.analyst === "number"
        ? payload.analyst
        : payload.analyst.id
      : null,
    isotope_instalation: payload.isotope_instalation,
    fondo_integral_reference: payload.fondo_integral_reference,
    fondo_integral_current_reference: payload.fondo_integral_current_reference,
    fondo_area_reference: payload.fondo_area_reference,
    fondo_area_reference_error: payload.fondo_area_reference_error,
    fondo_area_current_counts: payload.fondo_area_current_counts,
    analysis_type:
      payload.analysis_type && typeof payload.analysis_type === "object"
        ? payload.analysis_type.id
        : payload.analysis_type || null,
    detector: payload.detector?.id || null,
    filter:
      payload.filter && typeof payload.filter === "object"
        ? payload.filter.value
        : payload.filter || "",
    fondo_calculation: payload.fondo_calculation
      ? payload.fondo_calculation
      : [],
    month: payload.month,
    year: payload.year,
    integral_fondo_1: payload.integral_fondo_1,
    integral_fondo_2: payload.integral_fondo_2,
    counting_time_fondo_2: payload.counting_time_fondo_2,
    cps_integral_fondo_1: payload.cps_integral_fondo_1,
    cps_integral_fondo_2: payload.cps_integral_fondo_2,
    avg_integral_fondo: payload.avg_integral_fondo,
  };
};

export const calculateMedia = (newRow: any, rowsCalculation: any) => {
  const updatedRows = rowsCalculation.map((row: any) =>
    row.id === newRow.id ? { ...row, ...newRow } : row
  );
  return updatedRows;
};

export const calculateResult =
  (idInstalation, type) => async (rowsInput, rowsResult) => {
    const updatedRowsWithReferences = await useBackground
      .getState()
      .fetchReferenceValues(idInstalation, type);

    const fondoCalculation =
      updatedRowsWithReferences?.["fondo_calculation"] || [];

    const updatedResults = rowsInput.map((row, index) => {
      const referenceValue = fondoCalculation[index]?.["value_to_apply"] || 1;
      const variationValue = fondoCalculation[index]?.["variation"] || 0;
      const values = [row.cpm1, row.cpm2, row.cpm3, row.cpm4];
      const sum = values.reduce((acc, val) => acc + Number(val || 0), 0);
      const countValues = values.filter((val) => val != null && val !== 0);
      const media =
        countValues.length > 0
          ? parseFloat((sum / countValues.length / 1000).toFixed(4))
          : 0;

      const variation = (media / referenceValue - 1) * 100;

      const cpmValues = [row.cpm1, row.cpm2, row.cpm3, row.cpm4];
      const validCpmCount = cpmValues.reduce((count, value) => {
        return count + (value != null && value !== 0 ? 1 : 0);
      }, 0);

      let result: string = TYPE_RESULT_TABLE.KEEP;
      const sameSign = variationValue * variation > 0;

      if (validCpmCount === 1) {
        if (media != 0 && referenceValue == 0) {
          result = TYPE_RESULT_TABLE.CHANGE;
        } else if (
          !sameSign &&
          Math.abs(variation) > 10 &&
          Math.abs(variationValue) > 10
        ) {
          result = TYPE_RESULT_TABLE.CHANGE;
        }
      } else if (validCpmCount > 1) {
        if (Math.abs(variation) > 10) {
          result = TYPE_RESULT_TABLE.CHANGE;
        }
      }

      let value_to_apply = referenceValue;
      if (result === TYPE_RESULT_TABLE.CHANGE) {
        value_to_apply = media;
      }
      return {
        ...rowsResult[index],
        media: media,
        reference_value: referenceValue,
        variation: variation.toFixed(2),
        result: result,
        value_to_apply:
          media !== 0 && value_to_apply === 0 ? media : value_to_apply,
      };
    });

    return updatedResults;
  };

export const getDefaultValuesFondos = async (
  background?: BackgroundListType,
  user?: UserType
): Promise<IFormNewBackground> => {
  const today = new Date();
  const fondo_calculation = background?.fondo_calculation;

  const rowsInput =
    background?.type !== PROCESS_OPTIONS_VALUE.GAMMA && fondo_calculation
      ? fondo_calculation.map((item, index) => ({
          id: item.id,
          detector: item.detector,
          cpm1: item.cpm1 || 0,
          cpm2: item.cpm2 || 0,
          cpm3: item.cpm3 || 0,
          cpm4: item.cpm4 || 0,
        }))
      : initialRowsCalculation;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const rowsResult: any[] =
    background?.type !== PROCESS_OPTIONS_VALUE.GAMMA && fondo_calculation
      ? fondo_calculation.map((item, index) => ({
          id: item.id,
          media:
            item.media !== undefined && item.media !== null
              ? typeof item.media === "string"
                ? parseFloat(item.media) || 0
                : item.media
              : 0,
          reference_value:
            item.reference_value !== undefined && item.reference_value !== null
              ? typeof item.reference_value === "string"
                ? parseFloat(item.reference_value) || 0
                : item.reference_value
              : 0,
          variation:
            item.variation !== undefined && item.variation !== null
              ? typeof item.variation === "string"
                ? parseFloat(item.variation) || 0
                : item.variation
              : 0,
          result: item.result || 0,
          value_to_apply:
            item.value_to_apply !== undefined && item.value_to_apply !== null
              ? typeof item.value_to_apply === "string"
                ? parseFloat(item.value_to_apply) || 0
                : item.value_to_apply
              : 0,
        }))
      : initialRowsResult;

  const results =
    background?.instalation?.id &&
    background?.type &&
    background?.type !== PROCESS_OPTIONS_VALUE.GAMMA
      ? await calculateResult(background.instalation.id, background.type)(
          rowsInput,
          rowsResult
        )
      : [];

  const tableData =
    background?.type === PROCESS_OPTIONS_VALUE.GAMMA && fondo_calculation
      ? fondo_calculation.map((item) => ({
          id: item.id,
          isotope_instalation: typeof item.isotope_instalation
            ? item.isotope_instalation
            : null,
          energy: item.energy || "0.0",
          fondo_integral_reference: item.fondo_integral_reference || "",
          fondo_integral_current_reference:
            item.fondo_integral_current_reference || "",
          fondo_integral_current_reference_calculated:
            item.fondo_integral_current_reference_calculated || "",
          fondo_integral: item.fondo_integral || "",
          lid_variation: item.lid_variation || "",
          fondo_area_reference: item.fondo_area_reference || "",
          fondo_area_reference_error: item.fondo_area_reference_error || "",
          fondo_area_current_counts: item.fondo_area_current_counts || "",
          fondo_area_current_cps: item.fondo_area_current_cps || "",
          fondo_area_error: item.fondo_area_error || "",
          fondo_area_variation: item.fondo_area_variation || "",
          fondo_integration_to_apply: item.fondo_integration_to_apply || "",
          fondo_area_to_apply: item.fondo_area_to_apply || "",
          fondo_area_error_to_apply: item.fondo_area_error_to_apply || "",
        }))
      : [];

  return {
    id: background?.id,
    type: background?.type
      ? PROCESS_OPTIONS.find((option) => option.value === background?.type)
      : undefined,
    counting_time: background?.counting_time,
    creation_date: background?.creation_date || today,
    calculation_date: background?.calculation_date || undefined,
    equipment: background?.equipment,
    instalation: background?.instalation,
    analyst: background?.analyst || user,
    isotope_instalation: background?.isotope_instalation,
    energy: background?.energy,
    fondo_integral_reference: background?.fondo_integral_reference,
    fondo_integral_current_reference:
      background?.fondo_integral_current_reference,
    analysis_type: background?.analysis_type,
    detector: background?.detector || background?.equipment.codet,
    filter: background?.filter
      ? MEDIO_FILTER_OPTIONS.find(
          (option) => option.value === background.filter
        )
      : undefined,
    description: background?.description || "",
    code: background?.code || undefined,
    rowsInput: rowsInput || [],
    rowsResult: rowsResult || [],
    rowsCalculation: rowsInput || [],
    results,
    tableData,
    month: background?.month,
    year: background?.year,
    integral_fondo_1: background?.integral_fondo_1,
    integral_fondo_2: background?.integral_fondo_2,
    counting_time_fondo_2: background?.counting_time_fondo_2,
    cps_integral_fondo_1: background?.cps_integral_fondo_1,
    cps_integral_fondo_2: background?.cps_integral_fondo_2,
    avg_integral_fondo: background?.avg_integral_fondo,
  };
};

export const processDataAlfaBeta = (
  results: any[],
  rowsCalculation: any[],
  calculationDate: string
) => {
  return rowsCalculation.map((result) => {
    const calculationData = results.find((row) => row.id === result.id);

    if (!calculationData) {
      return {
        ...result,
        calculation_date: calculationDate,
        id: typeof result.id === "string" ? undefined : result.id,
      };
    }

    const { id, ...rest } = result;

    return {
      ...rest,
      ...{
        id: typeof result.id === "string" ? undefined : result.id,
        fondo: result.fondo || null,
        detector: result.detector || null,
        cpm1: result.cpm1 || 0,
        cpm2: result.cpm2 || 0,
        cpm3: result.cpm3 || 0,
        cpm4: result.cpm4 || 0,
        value_to_apply: calculationData.value_to_apply || "",
        calculation_date: calculationDate,
        variation: calculationData.variation || "",
        reference_value: calculationData.reference_value || "",
        result: calculationData.result || "",
        media: calculationData.media || 0,
      },
    };
  });
};

/**
 * Convierte un valor que puede ser string o número a número de forma segura
 */
const toNumber = (value: any, defaultValue: number = 0): number => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const cleanValue = value.replace("%", "").trim();
    const parsed = parseFloat(cleanValue);
    return isNaN(parsed) ? defaultValue : parsed;
  }
  return defaultValue;
};

/**
 * Analiza el histórico de fondos y aplica las casuísticas según documento LIDIA
 * para calcular "Fondo Integral a Aplicar", "Fondo Área a Aplicar" y "Error Fondo Área a Aplicar"
 * 
 * @param currentMeasurement - Medición actual
 * @param historicalData - Array de mediciones históricas ordenadas por fecha
 * @param isotopeId - ID del isótopo a analizar
 * @returns Objeto con los valores calculados según casuísticas
 */
export const applyBackgroundCasuistics = (
  currentMeasurement: any,
  historicalData: BackgroundListType[],
  isotopeId: number
) => {
  // Extraer datos de la medición actual
  const currentCalc = currentMeasurement.fondo_calculation?.find(
    (fc: any) => fc.isotope_instalation?.id === isotopeId
  );
  
  if (!currentCalc) {
    return null;
  }

  const currentMonth = currentMeasurement.month;
  const currentYear = currentMeasurement.year;
  const lidVariation = toNumber(currentCalc.lid_variation);
  const areaVariation = toNumber(currentCalc.fondo_area_variation);
  const integralActualCps = toNumber(currentCalc.fondo_integral_current_reference_calculated);
  const integralReferenciaCps = toNumber(currentCalc.fondo_integral_reference);
  const areaActualCps = toNumber(currentCalc.fondo_area_current_cps);
  const areaReferenciaCps = toNumber(currentCalc.fondo_area_reference);
  const errorAreaActual = toNumber(currentCalc.fondo_area_error);
  const errorAreaReferencia = toNumber(currentCalc.fondo_area_reference_error);

  // Filtrar histórico del mismo isótopo
  const historicalMeasurements = historicalData
    .filter(bg => bg.id !== currentMeasurement.id)
    .map(bg => {
      const calc = bg.fondo_calculation?.find(
        (fc: any) => fc.isotope_instalation?.id === isotopeId
      );
      if (!calc) return null;
      
      return {
        ...bg,
        calculation: calc,
        lidVariation: toNumber(calc.lid_variation),
        areaVariation: toNumber(calc.fondo_area_variation),
      };
    })
    .filter((item): item is NonNullable<typeof item> => item !== null)
    .sort((a, b) => {
      const yearA = a.year || 0;
      const yearB = b.year || 0;
      if (yearA !== yearB) return yearA - yearB;
      return (a.month || 0) - (b.month || 0);
    });

  // Obtener mediciones del mes actual
  const currentMonthMeasurements = historicalMeasurements.filter(
    (m: any) => m.month === currentMonth && m.year === currentYear
  );

  // Obtener última medición válida
  const lastMeasurement = historicalMeasurements.length > 0 
    ? historicalMeasurements[historicalMeasurements.length - 1] 
    : null;

  // Variables de resultado
  let fondoIntegralToApply = integralReferenciaCps;
  let fondoAreaToApply = areaReferenciaCps;
  let errorAreaToApply = 0;

  // === CASUÍSTICAS FONDO INTEGRAL ===
  
  // Caso: Sin histórico (primer contaje)
  if (historicalMeasurements.length === 0) {
    // Mantener referencia incluso si |LID| > 5%
    fondoIntegralToApply = integralReferenciaCps;
  }
  // Caso: |Variación % LID| < 5%
  else if (Math.abs(lidVariation) < 5) {
    // Mantener valor vigente
    fondoIntegralToApply = lastMeasurement 
      ? toNumber(lastMeasurement.calculation.fondo_integration_to_apply, integralReferenciaCps)
      : integralReferenciaCps;
  }
  // Caso: Dos contajes en el mismo mes con |LID| ≥ 5% y mismo signo
  else if (currentMonthMeasurements.length === 1) {
    const otherMeasurement = currentMonthMeasurements[0];
    const otherLidVar = otherMeasurement.lidVariation;
    
    if (Math.abs(otherLidVar) >= 5 && Math.sign(lidVariation) === Math.sign(otherLidVar)) {
      // Promedio de los dos fondos integrales actuales
      const otherIntegralCps = toNumber(otherMeasurement.calculation.fondo_integral_current_reference_calculated);
      fondoIntegralToApply = (integralActualCps + otherIntegralCps) / 2;
    } else {
      // Signos opuestos o uno < 5%: mantener valor previo
      fondoIntegralToApply = lastMeasurement 
        ? toNumber(lastMeasurement.calculation.fondo_integration_to_apply, integralReferenciaCps)
        : integralReferenciaCps;
    }
  }
  // Caso: Un solo contaje en el mes con |LID| ≥ 5%
  else if (currentMonthMeasurements.length === 0 && Math.abs(lidVariation) >= 5) {
    // Verificar si hay medición del mes anterior con |LID| ≥ 5% y mismo signo
    const prevMonth = currentMonth === 1 ? 12 : currentMonth - 1;
    const prevYear = currentMonth === 1 ? currentYear - 1 : currentYear;
    const prevMonthMeasurements = historicalMeasurements.filter(
      (m: any) => m.month === prevMonth && m.year === prevYear
    );
    
    if (prevMonthMeasurements.length === 1) {
      const prevMeasurement = prevMonthMeasurements[0];
      const prevLidVar = prevMeasurement.lidVariation;
      
      if (Math.abs(prevLidVar) >= 5 && Math.sign(lidVariation) === Math.sign(prevLidVar)) {
        // Dos meses consecutivos con |LID| ≥ 5% y mismo signo: promedio
        const prevIntegralCps = toNumber(prevMeasurement.calculation.fondo_integral_current_reference_calculated);
        fondoIntegralToApply = (integralActualCps + prevIntegralCps) / 2;
        // Nota: La referencia se actualizará en el mes siguiente
      } else {
        // No cumple condiciones: mantener valor previo
        fondoIntegralToApply = lastMeasurement 
          ? toNumber(lastMeasurement.calculation.fondo_integration_to_apply, integralReferenciaCps)
          : integralReferenciaCps;
      }
    } else {
      // No hay medición única del mes anterior: mantener valor previo
      fondoIntegralToApply = lastMeasurement 
        ? toNumber(lastMeasurement.calculation.fondo_integration_to_apply, integralReferenciaCps)
        : integralReferenciaCps;
    }
  }

  // === CASUÍSTICAS FONDO ÁREA ===
  
  // Caso: |Variación Fondo Área| < 5%
  if (Math.abs(areaVariation) < 5) {
    // Mantener referencia
    fondoAreaToApply = areaReferenciaCps;
    errorAreaToApply = 0;
  }
  // Caso: Dos contajes en el mismo mes con |Variación| ≥ 5% y mismo signo
  else if (currentMonthMeasurements.length === 1) {
    const otherMeasurement = currentMonthMeasurements[0];
    const otherAreaVar = otherMeasurement.areaVariation;
    
    if (Math.abs(otherAreaVar) >= 5 && Math.sign(areaVariation) === Math.sign(otherAreaVar)) {
      // Promedio de los dos fondos de área actuales
      const otherAreaCps = toNumber(otherMeasurement.calculation.fondo_area_current_cps);
      fondoAreaToApply = (areaActualCps + otherAreaCps) / 2;
      // Error asociado al nuevo fondo (calculado)
      const countingTime = toNumber(currentMeasurement.counting_time, 1);
      errorAreaToApply = Math.sqrt(fondoAreaToApply / countingTime);
    } else {
      // No cumple condiciones: mantener valor previo
      fondoAreaToApply = lastMeasurement 
        ? toNumber(lastMeasurement.calculation.fondo_area_to_apply, areaReferenciaCps)
        : areaReferenciaCps;
      errorAreaToApply = lastMeasurement 
        ? toNumber(lastMeasurement.calculation.fondo_area_error_to_apply)
        : 0;
    }
  }
  // Caso: Un solo contaje en el mes con |Variación| ≥ 5%
  else if (currentMonthMeasurements.length === 0 && Math.abs(areaVariation) >= 5) {
    // Verificar si hay medición del mes anterior
    const prevMonth = currentMonth === 1 ? 12 : currentMonth - 1;
    const prevYear = currentMonth === 1 ? currentYear - 1 : currentYear;
    const prevMonthMeasurements = historicalMeasurements.filter(
      (m: any) => m.month === prevMonth && m.year === prevYear
    );
    
    if (prevMonthMeasurements.length === 1) {
      const prevMeasurement = prevMonthMeasurements[0];
      const prevAreaVar = prevMeasurement.areaVariation;
      
      if (Math.abs(prevAreaVar) >= 5 && Math.sign(areaVariation) === Math.sign(prevAreaVar)) {
        // Dos meses consecutivos con |Variación| ≥ 5% y mismo signo: promedio
        const prevAreaCps = toNumber(prevMeasurement.calculation.fondo_area_current_cps);
        fondoAreaToApply = (areaActualCps + prevAreaCps) / 2;
        // Error asociado al nuevo fondo
        const countingTime = toNumber(currentMeasurement.counting_time, 1);
        errorAreaToApply = Math.sqrt(fondoAreaToApply / countingTime);
      } else {
        // No cumple: mantener valor previo
        fondoAreaToApply = lastMeasurement 
          ? toNumber(lastMeasurement.calculation.fondo_area_to_apply, areaReferenciaCps)
          : areaReferenciaCps;
        errorAreaToApply = lastMeasurement 
          ? toNumber(lastMeasurement.calculation.fondo_area_error_to_apply)
          : 0;
      }
    } else {
      // No hay medición única del mes anterior: mantener valor previo
      fondoAreaToApply = lastMeasurement 
        ? toNumber(lastMeasurement.calculation.fondo_area_to_apply, areaReferenciaCps)
        : areaReferenciaCps;
      errorAreaToApply = lastMeasurement 
        ? toNumber(lastMeasurement.calculation.fondo_area_error_to_apply)
        : 0;
    }
  }

  return {
    fondo_integration_to_apply: fondoIntegralToApply,
    fondo_area_to_apply: fondoAreaToApply,
    fondo_area_error_to_apply: errorAreaToApply,
  };
};
